export const URLS = {
  additional_email_setup: 'https://community.instructure.com/en/kb/articles/662887-how-do-i-add-an-additional-email-address-as-a-contact-method-in-canvas',
  content_licenses: 'https://community.instructure.com/en/kb/articles/664552',
  how_to_use_commons: 'https://community.instructure.com/en/kb/articles/664537',
  how_to_import_and_view_resource: 'https://community.instructure.com/en/kb/articles/664539',
  how_to_share_resources: 'https://community.instructure.com/en/kb/articles/664556',
  how_to_view_updates: 'https://community.instructure.com/en/kb/articles/664549',
  users: 'https://community.instructure.com/en/kb/canvas_commons-guide',
  privacy: 'https://www.instructure.com/privacy-security',
  type_of_document_and_media_files: 'https://community.instructure.com/en/kb/articles/664554',
  what_is_canvas_commons: 'https://community.instructure.com/en/kb/articles/664521',
};
